import * as Bootstrap from "bootstrap";
// ---------------------------------------------------------
//  Mobile menu
// ---------------------------------------------------------
const mobileNavBtn = document.getElementById("mobile-nav");

if(mobileNavBtn) {

    mobileNavBtn.addEventListener("click", (e, i) => {
        mobileNavBtn.classList.toggle("open");
    })
}
// ---------------------------------------------------------
//  Back to top / Scrollspy
// ---------------------------------------------------------
const scrollTrigger = 30;
const menu = document.querySelector('nav.navbar');
const bttBtn = document.getElementById("back-to-top");
const updateScrollPosition = () => {
    window.scrollY > 100 ? menu.classList.add("scroll") : menu.classList.remove("scroll");
    window.scrollY > 500 ? bttBtn.classList.add("show") : bttBtn.classList.remove("show");
}

window.onscroll = () => updateScrollPosition();

document.addEventListener('DOMContentLoaded',
    () => {
        updateScrollPosition();
    }, {once: true}
)
